module.exports = __webpack_public_path__ + "img/skype-call.30273889.png";